import Layout from "@/components/Layout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { 
  Building, 
  Calendar, 
  MapPin, 
  Users,
  Star,
  ExternalLink,
  Award
} from "lucide-react";

const References = () => {
  const projects = [
    {
      id: 1,
      title: "Salle de Conférence Moderne",
      client: "Entreprise Privée",
      category: "Audiovisuel & Conférence",

      location: "Payerne, Suisse",
      description: "Conseil et installation d'un écran 75\" et une barre de son. Installation d'un TapeShare et tirage des câbles.",
      services: ["Installation écran 75\"", "Barre de son professionnelle", "TapeShare", "Tirage de câbles"],
      images: ["/images/tempImagec0OT2l.jpg", "/images/tempImageM0YKqo.jpg", "/images/tempImageEZ0YuN.jpg", "/images/tempImagezHDEr4.jpg"],

      rating: 5
    },
    {
      id: 2,
      title: "Salon Privé",
      client: "Client Privé",
      category: "Audiovisuel Résidentiel",
      location: "Chavornay, Suisse",
      description: "Installation murale d'un écran 75\" avec système audio Sonos pour un salon moderne.",
      services: ["Installation murale écran 75\"", "Système audio Sonos", "Câblage discret", "Configuration domotique"],
      images: ["/images/tempImageYAfjZR.jpg", "/images/tempImage4oBWjj.jpg"],
      rating: 5
    },
    {
      id: 3,
      title: "Salon Privé avec Sonorisation",
      client: "Client Privé",
      category: "Sonorisation Résidentielle",
      location: "Payerne, Suisse",
      description: "Sonorisation professionnelle avec matrice audio et commande motorisée pour un salon privé.",
      services: ["Matrice audio professionnelle", "Commande motorisée", "Sonorisation intégrée", "Câblage invisible"],
      images: ["/images/tempImagea2J1oY.jpg", "/images/tempImagedCM0Ml.jpg", "/images/tempImageE1Iuyu.jpg", "/images/tempImage4GAIiO.jpg"],
      rating: 5
    },
    {
      id: 4,
      title: "Magasin d'Alimentation",
      client: "Commerce Local",
      category: "Installation Commerciale",
      location: "Payerne, Suisse",
      description: "Installation sonorisation, vidéo surveillance et affichage dynamique pour un magasin d'alimentation.",
      services: ["Sonorisation commerciale", "Vidéo surveillance", "Affichage dynamique", "Système intégré"],
      images: ["/images/tempImagec1KP1m.jpg", "/images/tempImageRqaOfS.jpg", "/images/tempImageHcCEWP.jpg", "/images/tempImageYaPfTT.jpg", "/images/tempImagePmi0bI.jpg", "/images/tempImageTE9J2w.jpg"],
      rating: 5
    },
    {
      id: 5,
      title: "Sonorisation de Grande Salle",
      client: "Centre de Conférences",
      category: "Sonorisation Professionnelle",
      location: "Valbroye, Suisse",
      description: "Installation d'un système de sonorisation professionnel pour une grande salle de conférences avec équipements Audac et JTS.",
      services: ["Haut-Parleur Audac", "Amplificateur Audac", "Matrice Audac", "Micro sans fil JTS", "Traitement acoustique", "Contrôle centralisé"],
      images: ["/images/tempImagevcCoEK.jpg", "/images/tempImageqEQ0YK.jpg", "/images/tempImagebRj6eD.jpg", "/images/tempImageGKtw9A.jpg"],
      rating: 5
    },
    {
      id: 6,
      title: "Centre de Pompier de Rue",
      client: "Service d'Incendie et de Secours",
      category: "Installation Audiovisuelle Complète",
      location: "Rue, Suisse",
      description: "Installation audiovisuelle et domotique complète pour un centre de pompiers moderne avec équipements de pointe.",
      services: ["Installation écran interactif sur chariot", "Sonorisation pour toute la halle", "Sonorisation salle de conférence", "Projecteur vidéo", "Contrôleur Cue", "Domotique audiovisuelle"],
      images: ["/images/tempImageIDKk8y.jpg", "/images/tempImagec1BSD1.jpg", "/images/tempImage8a8Ehn.jpg", "/images/tempImageMqlJ36.jpg", "/images/tempImagej0rMYj.jpg", "/images/tempImageZ4Jcha.jpg"],
      rating: 5
    },
    {
      id: 7,
      title: "Salle de Conférence Moderne",
      client: "Entreprise Privée",
      category: "Installation Audiovisuelle Professionnelle",
      location: "Thierrens",
      description: "Installation complète d'une salle de conférence moderne avec projecteur vidéo, sonorisation et gestion Extron.",
      services: ["Installation projecteur vidéo", "Sonorisation professionnelle", "Micro sans fil", "Gestion Extron", "Contrôle centralisé", "Câblage structuré"],
      images: ["/images/edc5ddb9-ea06-4dcf-a5db-9f611b0fea71.jpeg", "/images/tempImageiDNAxf.jpg", "/images/1660ae28-bcc5-4cce-9940-9991593ea4b7.jpeg", "/images/7bad72f7-4bbd-4ac8-abee-ad595d5a3742.jpeg", "/images/29176478-8a42-4d98-a3fd-45eb060d5297.jpeg"],
      rating: 5
    },
    {
      id: 8,
      title: "Installation Sonorisation Église",
      client: "Paroisse de Dompierre",
      category: "Sonorisation Religieuse",
      location: "Dompierre VD, Suisse",
      description: "Installation complète d'un système de sonorisation pour église avec équipements Audac professionnels.",
      services: ["Installation haut-parleurs", "Installation amplificateur Audac", "Mélangeur Audac", "Câblage acoustique", "Réglages audio", "Formation utilisateurs"],
      images: ["/images/12e96294-0bd7-4691-ab00-3446d8f8890f.jpeg", "/images/cc90fb8a-3a38-4cdd-a9e4-8a51214a5edf.jpeg", "/images/507ba4fb-6c78-49f9-8375-e7c593b22667.jpeg", "/images/61a81056-34f3-4b14-a2d1-6b001e59390f.jpeg", "/images/da722a25-ff4d-4208-84f6-74bf8c862310.jpeg", "/images/tempImage1sjrsl.jpg"],
      rating: 5
    },
    {
      id: 9,
      title: "Installation Salle de Cinéma",
      client: "Résidence Privée",
      category: "Cinéma Maison Haut de Gamme",
      location: "Gstaad, Suisse",
      description: "Installation complète d'une salle de cinéma privée avec projecteur courte focale et amplificateur multizoom.",
      services: ["Installation haut-parleurs", "Projecteur courte focale", "Amplificateur multizoom", "Acoustique sur mesure", "Contrôle domotique", "Calibrage vidéo/audio"],
      images: ["/images/fd427269-e339-4fae-ab8a-fc4282ecd158.jpeg", "/images/8c7fdd71-751f-4a8b-8fbc-68882fe72bc1.jpeg", "/images/37d190af-81b0-4599-968f-af06147ebeca.jpeg", "/images/d5c986c2-042b-4521-90c5-84c432f329f3.jpeg", "/images/2863528a-1d50-4c27-ad6d-6a7f1e52d81c.jpeg", "/images/1908558d-6a0b-4d52-815f-420fa6e0451b.jpeg"],
      rating: 5
    }
  ];

  const stats = [
    { number: "500+", label: "Projets réalisés" },
    { number: "15+", label: "Années d'expérience" },
    { number: "100%", label: "Clients satisfaits" },
    { number: "24/7", label: "Support technique" }
  ];

  const certifications = [
    "Certification Barco",
    "Certification Audac Audio",
    "Certification Jablotron",
    "Certification Spinetix",
    "Certification RTI",
    "Certification The Savant"
  ];

  return (
    <Layout>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-background to-muted">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <Badge variant="outline" className="mb-4">
              Nos Références
            </Badge>
            <h1 className="text-4xl lg:text-5xl font-bold tracking-tight">
              Nos Réalisations
            </h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Découvrez quelques-unes de nos réalisations les plus marquantes. 
              Chaque projet témoigne de notre expertise et de notre engagement qualité.
            </p>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                Nos Réalisations
              </h2>
              <p className="text-lg text-muted-foreground">
                Une sélection de projets qui illustrent notre savoir-faire dans tous nos domaines d'expertise
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {projects.map((project) => (
                <Card key={project.id} className="overflow-hidden hover:shadow-elegant transition-all duration-300">
                  <div className="aspect-video bg-muted relative">
                    {project.images && project.images.length > 0 && (
                      <div className={`grid gap-1 h-full ${
                        project.images.length <= 4 
                          ? 'grid-cols-2' 
                          : 'grid-cols-3 grid-rows-2'
                      }`}>
                        {project.images.slice(0, 6).map((img, idx) => (
                          <img 
                            key={idx}
                            src={img} 
                            alt={`${project.title} - Image ${idx + 1}`}
                            className="w-full h-full object-cover"
                          />
                        ))}
                      </div>
                    )}
                    <div className="absolute top-4 left-4">
                      <Badge variant="secondary">{project.category}</Badge>
                    </div>

                  </div>
                  
                  <CardHeader>
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <CardTitle className="text-xl mb-2">{project.title}</CardTitle>
                        <CardDescription className="flex items-center space-x-4 text-sm">
                          <span className="flex items-center space-x-1">
                            <Building className="h-4 w-4" />
                            <span>{project.client}</span>
                          </span>
                          <span className="flex items-center space-x-1">
                            <MapPin className="h-4 w-4" />
                            <span>{project.location}</span>
                          </span>
                        </CardDescription>
                      </div>
                      <div className="flex items-center space-x-1">
                        {[...Array(project.rating)].map((_, i) => (
                          <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                        ))}
                      </div>
                    </div>
                  </CardHeader>
                  
                  <CardContent className="space-y-4">
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {project.description}
                    </p>
                    
                    <div className="space-y-2">
                      <h4 className="font-medium text-sm">Services fournis :</h4>
                      <div className="flex flex-wrap gap-2">
                        {project.services.map((service, idx) => (
                          <Badge key={idx} variant="outline" className="text-xs">
                            {service}
                          </Badge>
                        ))}
                      </div>
                    </div>
                    

                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="py-20 bg-muted/50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                Certifications & Qualifications
              </h2>
              <p className="text-lg text-muted-foreground">
                Notre équipe maintient ses compétences à jour grâce à des formations continues
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {certifications.map((cert, index) => (
                <div key={index} className="flex items-center space-x-3 p-4 bg-background rounded-lg shadow-sm">
                  <Award className="h-5 w-5 text-primary flex-shrink-0" />
                  <span className="font-medium">{cert}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary text-primary-foreground">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <h2 className="text-3xl lg:text-4xl font-bold">
              Votre Projet Sera Notre Prochaine Référence
            </h2>
            <p className="text-xl opacity-90 max-w-2xl mx-auto">
              Rejoignez nos clients satisfaits et bénéficiez de notre expertise 
              pour la réalisation de votre projet technologique
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" variant="secondary">
                Demander un Devis
              </Button>
              <Button size="lg" variant="outline" className="bg-transparent border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary">
                Voir Plus de Projets
                <ExternalLink className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default References;